import React, { FC, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  ActionsGroup,
  Dialog,
  DialogActions,
  Textarea,
  DialogContent,
  DialogTitle,
  FlatButton,
  TitleText,
  WaitingButton,
  ButtonsGroup,
  Description,
  IButtonItemProps,
} from "@evergis/ui";

import { useCalculatedAttributesVertex } from "./useCalculatedAttributesVertex";
import { useDialogReset, useDialogInfo } from "../../../hooks/useDialogs";
import { ButtonsGroupContainer, TitleDescription } from "./styled";

import { FeaturedDcExtendedGeometry } from "../../../ducks/selectFeatures/types";

export const CalculatedAttributesVertex: FC = () => {
  const { t } = useTranslation();
  const cancelDialog = useDialogReset();
  const dialogInfo = useDialogInfo();
  const dialogOptions = dialogInfo && dialogInfo.options;

  const { value, vertexCount, label } = dialogOptions as {
    value: FeaturedDcExtendedGeometry;
    vertexCount: number;
    label: string;
  };

  const [selectedFormat, setSelectedFormat] = useState<IButtonItemProps>({ label: "GeoJSON" });
  const { formatedValue, input, copyToBuffer } = useCalculatedAttributesVertex(value, selectedFormat.label);

  const calculatedAttributesDefault = useMemo(
    () => ({
      maxWidth: "45rem",
      title: t("calculatedAttributesVertex.vertices", { ns: "dialogs" }),
      inputLabel: `${t("calculatedAttributesVertex.chooseFormat", { ns: "dialogs" })}:`,
    }),
    [t],
  );

  return (
    <Dialog isOpen maxWidth={calculatedAttributesDefault.maxWidth} onCloseRequest={cancelDialog}>
      <DialogTitle>
        <TitleText>{calculatedAttributesDefault.title}</TitleText>
      </DialogTitle>
      <TitleDescription>
        {`${label}, ${t("calculatedAttributesVertex.vertexCount", {
          ns: "dialogs",
        })}: ${vertexCount}`}
      </TitleDescription>
      <ButtonsGroupContainer>
        <Description>{calculatedAttributesDefault.inputLabel}</Description>
        <ButtonsGroup
          options={[
            {
              label: "GeoJSON",
            },
            {
              label: "WKT",
            },
            {
              label: "KML",
            },
          ]}
          selected={selectedFormat}
          onClick={setSelectedFormat}
        />
      </ButtonsGroupContainer>
      <DialogContent>
        <Textarea height={"18rem"} innerRef={input} value={formatedValue} readOnly />
      </DialogContent>
      <DialogActions>
        <ActionsGroup>
          <WaitingButton primary onClick={copyToBuffer} isWaiting={false}>
            {t("calculatedAttributesVertex.copyAll", { ns: "dialogs" })}
          </WaitingButton>
          <FlatButton onClick={cancelDialog}>{t("actions.cancel", { ns: "common" })}</FlatButton>
        </ActionsGroup>
      </DialogActions>
    </Dialog>
  );
};
